export const boatConstants = {
  FETCH_BOAT_LOGBOOK_ENTRIES_SUCCESS: 'FETCH_BOAT_LOGBOOK_ENTRIES_SUCCESS',
  FETCH_BOAT_LOGBOOK_ENTRIES_LOADING: 'FETCH_BOAT_LOGBOOK_ENTRIES_LOADING',
  FETCH_BOAT_LOGBOOK_ENTRIES_ERROR: 'FETCH_BOAT_LOGBOOK_ENTRIES_ERROR',

  CREATE_BOAT_LOGBOOK_ENTRY_SUCCESS: 'CREATE_BOAT_LOGBOOK_ENTRY_SUCCESS',
  CREATE_BOAT_LOGBOOK_ENTRY_LOADING: 'CREATE_BOAT_LOGBOOK_ENTRY_LOADING',
  CREATE_BOAT_LOGBOOK_ENTRY_ERROR: 'CREATE_BOAT_LOGBOOK_ENTRY_ERROR',

  FETCH_ALL_AVAILABLE_BOATS_SUCCESS: 'FETCH_ALL_AVAILABLE_BOATS_SUCCESS',
  FETCH_ALL_AVAILABLE_BOATS_LOADING: 'FETCH_ALL_AVAILABLE_BOATS_LOADING',
  FETCH_ALL_AVAILABLE_BOATS_ERROR: 'FETCH_ALL_AVAILABLE_BOATS_ERROR',

  FETCH_BOAT_INFO_FOR_BOAT_SUCCESS: 'FETCH_BOAT_INFO_FOR_BOAT_SUCCESS',
  FETCH_BOAT_INFO_FOR_BOAT_LOADING: 'FETCH_BOAT_INFO_FOR_BOAT_LOADING',
  FETCH_BOAT_INFO_FOR_BOAT_ERROR: 'FETCH_BOAT_INFO_FOR_BOAT_ERROR',

  FETCH_USERS_FOR_BOAT_SUCCESS: 'FETCH_USERS_FOR_BOAT_SUCCESS',
  FETCH_USERS_FOR_BOAT_LOADING: 'FETCH_USERS_FOR_BOAT_LOADING',
  FETCH_USERS_FOR_BOAT_ERROR: 'FETCH_USERS_FOR_BOAT_ERROR',

  FETCH_ALL_AIS_POSITIONS_FOR_BOATS_LOADING: 'FETCH_ALL_AIS_POSITIONS_FOR_BOATS_LOADING',
  FETCH_ALL_AIS_POSITIONS_FOR_BOATS_SUCCESS: 'FETCH_ALL_AIS_POSITIONS_FOR_BOATS_SUCCESS',
  FETCH_ALL_AIS_POSITIONS_FOR_BOATS_ERROR: 'FETCH_ALL_AIS_POSITIONS_FOR_BOATS_ERROR',

  UPDATE_SELECTED_BOAT: 'UPDATE_SELECTED_BOAT',
  RESET_SELECTED_BOAT: 'RESET_SELECTED_BOAT',
  RESET_BOAT_LIST: 'RESET_BOAT_LIST',

  CREATE_NEW_BOAT: 'CREATE_NEW_BOAT',
  UPDATE_BOAT_FOR_SAVING: 'UPDATE_BOAT_FOR_SAVING',
  SAVING_NEW_BOAT: 'SAVING_NEW_BOAT',
  SAVING_NEW_BOAT_SUCCESSFUL: 'SAVING_NEW_BOAT_SUCCESSFUL',
  SAVING_NEW_BOAT_ERROR: 'SAVING_NEW_BOAT_ERROR',

  UPDATE_BOAT: 'UPDATE_BOAT',
  UPDATE_BOAT_SUCCESSFUL: 'UPDATE_BOAT_SUCCESSFUL',
  UPDATE_BOAT_ERROR: 'UPDATE_BOAT_ERROR',

  SAVE_NEW_BOAT_AS_DRAFT: 'SAVE_NEW BOAT_AS_DRAFT',

  SET_BOAT_AS_ACTIVE: 'SET_BOAT_AS_ACTIVE',
  SET_BOAT_AS_INACTIVE: 'SET_BOAT_AS_INACTIVE',

  GET_BOAT_TYPES: 'GET_BOAT_TYPES',
  GET_BOAT_TYPES_ERROR: 'GET_BOAT_TYPES_ERROR',
  GET_BOAT_TYPES_SUCCESS: 'GET_BOAT_TYPES_SUCCESS',

  GET_CLIENTS_FOR_USER: 'GET_CLIENTS_FOR_USER',
  GET_CLIENTS_FOR_USER_ERROR: 'GET_CLIENTS_FOR_USER_ERROR',
  GET_CLIENTS_FOR_USER_SUCCESS: 'GET_CLIENTS_FOR_USER_SUCCESS',

  FETCH_ACCESSGROUPS_FOR_CLIENT_LOADING: 'FETCH_ACCESSGROUPS_FOR_CLIENT_LOADING',
  FETCH_ACCESSGROUPS_FOR_CLIENT_SUCCESS: 'FETCH_ACCESSGROUPS_FOR_CLIENT_SUCCESS',
  FETCH_ACCESSGROUPS_FOR_CLIENT_ERROR: 'FETCH_ACCESSGROUPS_FOR_CLIENT_ERROR',

  GET_BOAT_TYPE_CATEGORIES: 'GET_BOAT_TYPE_CATEGORIES',
  GET_BOAT_TYPE_CATEGORIES_ERROR: 'GET_BOAT_TYPE_CATEGORIES_ERROR',
  GET_BOAT_TYPE_CATEGORIES_SUCCESS: 'GET_BOAT_TYPE_CATEGORIES_SUCCESS',

  GET_HULL_TYPES: 'GET_HULL_TYPES',
  GET_HULL_TYPES_ERROR: 'GET_HULL_TYPES_ERROR',
  GET_HULL_TYPES_SUCCESS: 'GET_HULL_TYPES_SUCCESS',

  GET_BOAT_TRADING_AREAS: 'GET_BOAT_TRADING_AREAS',
  GET_BOAT_TRADING_AREAS_ERROR: 'GET_BOAT_TRADING_AREAS_ERROR',
  GET_BOAT_TRADING_AREAS_SUCCESS: 'GET_BOAT_TRADING_AREAS_SUCCESS',

  UPLOAD_IMAGE_TO_BOAT: 'UPLOAD_IMAGE_TO_BOAT',
  UPLOAD_IMAGE_TO_BOAT_SUCCESS: 'UPLOAD_IMAGE_TO_BOAT_SUCCESS',
  UPLOAD_IMAGE_TO_BOAT_ERROR: 'UPLOAD_IMAGE_TO_BOAT_ERROR',

  FETCH_IMAGE_IDS_FOR_BOAT: 'FETCH_IMAGE_IDS_FOR_BOAT',
  FETCH_IMAGE_IDS_FOR_BOAT_SUCCESS: 'FETCH_IMAGE_IDS_FOR_BOAT_SUCCESS',
  FETCH_IMAGE_IDS_FOR_BOAT_ERROR: 'FETCH_IMAGE_IDS_FOR_BOAT_ERROR',

  FETCH_BOAT_AIS_POSITION_SUCCESS: 'FETCH_BOAT_AIS_POSITION_SUCCESS',
  FETCH_BOAT_AIS_POSITION_LOADING: 'FETCH_BOAT_AIS_POSITION_LOADING',
  FETCH_BOAT_AIS_POSITION_ERROR: 'FETCH_BOAT_AIS_POSITION_ERROR',

  UPDATE_BOAT_STATUS_STARTED: 'UPDATE_BOAT_STATUS_STARTED',
  UPDATE_BOAT_STATUS_SUCCESSFUL: 'UPDATE_BOAT_STATUS_SUCCESSFUL',
  UPDATE_BOAT_STATUS_ERROR: 'UPDATE_BOAT_STATUS_ERROR',

  DELETE_IMAGE_FOR_BOAT: 'DELETE_IMAGE_FOR_BOAT',
  DELETE_IMAGE_FOR_BOAT_SUCCESSFUL: 'DELETE_IMAGE_FOR_BOAT_SUCCESSFUL',
  DELETE_IMAGE_FOR_BOAT_ERROR: 'DELETE_IMAGE_FOR_BOAT_ERROR',

  SET_IMAGE_AS_MAIN_IMAGE: 'SET_IMAGE_AS_MAIN_IMAGE',
  SET_IMAGE_AS_MAIN_IMAGE_SUCCESSFUL: 'SET_IMAGE_AS_MAIN_IMAGE_SUCCESSFUL',
  SET_IMAGE_AS_MAIN_IMAGE_ERROR: 'SET_IMAGE_AS_MAIN_IMAGE_ERROR',

  GET_SUPPLIERS_LOADING: 'GET_SUPPLIERS_LOADING',
  GET_SUPPLIERS_SUCCESS: 'GET_SUPPLIERS_SUCCESS',
  GET_SUPPLIERS_ERROR: 'GET_SUPPLIERS_ERROR',

  RESET_ERROR: 'RESET_ERROR',
} as const
